const FEATURE_FLAGS = {
  READY_TO_RENT: false,
  INITIAL_LISTING_RENT_RANGE: true
};

export { FEATURE_FLAGS };
